import { handleActions } from 'redux-actions';
import {
  autoTieoutMapedElementsLoading,
  autoTieoutMapedElementsLoaded,
  autoTieoutMapedElementsError,
  setTargetElementClicked,
  setSourceElementClicked,
  removeTargetElementClicked,
  removeSourceElementClicked,
  clearAutoTieoutMapedElements,
} from 'store/actions/auto-tieout/mapped-elements-actions';
import AutoTieoutMappedElements from 'models/api/auto-tieout/mapped-elements-api-model';
import { resetMappedElements } from 'store/actions/trial-balance/mapped-element-action';

export default handleActions(
  {
    [autoTieoutMapedElementsLoading]: (autoTieoutMappedElements) => {
      return autoTieoutMappedElements.setLoading();
    },
    [autoTieoutMapedElementsLoaded]: (
      autoTieoutMappedElements,
      { payload },
    ) => {
      return autoTieoutMappedElements.setLoaded(payload);
    },
    [autoTieoutMapedElementsError]: (autoTieoutMappedElements, { payload }) => {
      return autoTieoutMappedElements.setError(payload);
    },
    [clearAutoTieoutMapedElements]: (autoTieoutMappedElements) => {
      return autoTieoutMappedElements.clear();
    },
    [setTargetElementClicked]: (autoTieoutMappedElements, { payload }) => {
      return autoTieoutMappedElements.setTargetElementClicked(payload);
    },
    [setSourceElementClicked]: (autoTieoutMappedElements, { payload }) => {
      return autoTieoutMappedElements.setSourceElementClicked(payload);
    },
    [removeTargetElementClicked]: (autoTieoutMappedElements) => {
      return autoTieoutMappedElements.setTargetElementClicked(null);
    },
    [removeSourceElementClicked]: (autoTieoutMappedElements) => {
      return autoTieoutMappedElements.setSourceElementClicked(null);
    },
    [resetMappedElements]: () => {
      return new AutoTieoutMappedElements();
    },
  },
  new AutoTieoutMappedElements(),
);
